import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Select from "../../ui/Select/Select";
import Table from "../../ui/Table/Table";
import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";
import "./Buy2.scss";
import classnames from "classnames";
import DateRange from "../../ui/DateRange/DateRange";
import Button from "../../ui/Button/Button";
import Loader from "../../ui/Loader/Loader";
import moment from "moment";

import useSort from "../../hooks/useSort";
import useSearch from "../../hooks/useSearch";

import { BuyoutGroupsStatService } from "../../utils/api";

import GroupSelect from "./GroupSelect";

import { teaserListDetail } from "../../utils/urls";
import spaceint2 from "../../utils/spaceint2";
import { buyoutStatus } from "../../constants";

const renderSpaceint2 = ({ data, columnInfo }) => (
  <span>{spaceint2(data[columnInfo.accessor])}</span>
);
const renderSummarySpaceint2 = ({ summaryInfo, summary }) => (
  <span>{spaceint2(summary[summaryInfo.accessor])}</span>
);

const extraColumns = [
  {
    _key: "e1",
    className: "table__border-right",
    colSpan: 5
  },
  {
    _key: "e2",
    className: "table__border-right",
    colSpan: 3,
    title: "rb.mail.ru"
  },
  {
    _key: "e3",
    title: "Content"
  },
  {
    _key: "e4",
    title: ""
  }
];

const columns = [
  {
    className: "id1",
    dataClassName: "id1",
    title: "ID (mail)",
    accessor: "id",
    renderDataCell: ({ columnInfo, data }) => {
      return (
        <div>
          <span
            className={classnames("page-buy__teaser-status", {
              green: !data.is_stopped,
              gray: data.is_stopped
            })}
          />
          <span>
            <a
              href={`https://rb.mail.ru/banners/${data[columnInfo.accessor]}/`}
              target="_blank"
            >
              {data[columnInfo.accessor]}
            </a>
          </span>
        </div>
      );
    }
  },
  {
    className: "id2",
    dataClassName: "id2",
    title: "ID (cntnt)",
    accessor: "content_ids",
    renderDataCell: ({ data }) => {
      return data.content_ids.map(id => {
        return (
          <Link
            className="page-buy__teaser-url"
            to={teaserListDetail(id)}
            target="_blank"
          >
            {id}
          </Link>
        );
      });
    }
  },
  {
    className: "title",
    dataClassName: "title",
    title: "Заголовок",
    accessor: "title"
  },
  {
    className: "tgb",
    dataClassName: "tgb",
    title: "ТГБ",
    accessor: "slot_name"
  },
  {
    className: "table__border-right arpu",
    dataClassName: "table__border-right arpu",
    summaryClassName: "table__border-right arpu",
    title: "ARPU (M)",
    accessor: "arpu_model"
  },
  {
    className: "shows",
    dataClassName: "shows",
    title: "Показы",
    accessor: "shows",
    renderDataCell: renderSpaceint2
  },
  {
    className: "ctr",
    dataClassName: "ctr",
    title: "CTR",
    accessor: "ctr"
  },
  {
    className: "table__border-right clicks1",
    dataClassName: "table__border-right clicks1",
    summaryClassName: "table__border-right clicks1",
    title: "Переходы",
    accessor: "clicks",
    renderDataCell: renderSpaceint2
  },
  {
    className: "clicks2",
    dataClassName: "clicks2",
    title: "Переходы",
    accessor: "content_clicks",
    renderDataCell: renderSpaceint2
  },
  {
    className: "r_kpi",
    dataClassName: "r_kpi",
    title: "KPI",
    accessor: "r_kpi"
  }
];

const summaryColumns = [
  {
    title: "Итого",
    colSpan: 4
  },
  {
    accessor: "arpu_model",
    className: "table__border-right",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "shows",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "ctr"
  },
  {
    accessor: "clicks",
    className: "table__border-right",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "content_clicks",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "r_kpi",
    className: "r_kpi"
  }
];

const sortOptions = [
  { label: "status", value: "status" },
  { label: "incoming", value: "incoming" },
  { label: "banner_id", value: "banner_id" }
];

const Buy = ({ location, history }) => {
  const [state, setState] = useState({ stat: [], summary: null });
  const [loading, setLoading] = useState(true);
  const [hasMoreStat, setHasMoreStat] = useState(true);

  const [search, setSearch] = useSearch(
    {
      date_from: moment().format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
      group: "",
      page: 1,
      order_by: "status"
    },
    location,
    history
  );
  const curPage = parseInt(search.page);

  useEffect(() => {
    setLoading(true);
    BuyoutGroupsStatService({ ...search, with_summary: state.summary == null })
      .then(data => {
        setHasMoreStat(data.stat.length !== 0);

        state.stat.push(...data.stat);
        if (data.summary) {
          state.summary = data.summary;
        }
        setState(state);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  const onGroupChange = item => {
    setSearch({
      group: item.value,
      page: 1
    });
    setState({ stat: [], summary: null });
  };

  const onDateChange = ({ startDate, endDate }) => {
    setSearch({
      date_from: moment(startDate).format("YYYY-MM-DD"),
      date_to: moment(endDate).format("YYYY-MM-DD"),
      page: 1
    });
    setState({ stat: [], summary: null });
  };

  const onSortChange = item => {
    setSearch({
      order_by: item.value,
      page: 1
    });
    setState({ stat: [], summary: null });
  };

  return (
    <div className="page-buy2">
      <FixedHeader>
        <PrimaryHeader className="x">
          <span className="header__title">Выкуп 2.0 (beta)</span>

          <GroupSelect
            placeholder="Все кампании"
            className="page-buy__status"
            theme="dark"
            value={parseInt(search.group)}
            onSelect={onGroupChange}
          />

          <Select
            theme="dark"
            options={sortOptions}
            value={search.order_by}
            onSelect={onSortChange}
          />
        </PrimaryHeader>
      </FixedHeader>

      <div className="content-body content-body__with-fixed">
        <div className="page-buy__date-range">
          <DateRange
            className="left"
            onChange={onDateChange}
            startDate={moment(search.date_from)}
            endDate={moment(search.date_to)}
          />
        </div>

        <Table
          columns={columns}
          extraColumns={extraColumns}
          data={state.stat}
          summary={state.summary || {}}
          summaryColumns={summaryColumns}
          className="buy"
          getTrProps={({ data }) => {
            if (data.is_stopped) {
              return { className: "inactive" };
            }
          }}
        />

        {loading && <Loader />}

        {hasMoreStat && !loading && (
          <Button
            className="more-btn"
            color="blue"
            onClick={() => setSearch({ page: curPage + 1 })}
          >
            Еще
          </Button>
        )}
      </div>
    </div>
  );
};

export default Buy;
